import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { CHUYENKHOA_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Editor from '@app/components/editor/Editor';

const schema = yup.object().shape({
    maChuyenKhoa: yup.string().required(messageError.emptyMessage).max(50, 'Mã chuyên khoa không được vượt quá 50 ký tự'),
    tenChuyenKhoa: yup.string().required(messageError.emptyMessage).max(255, 'Tên chuyên khoa không được vượt quá 255 ký tự')
});

const ChuyenKhoaEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const params = new URLSearchParams(location.search.substring(1));
    const itemId = params.get('id');

    const itemQuery = useQuery(['chuyenKhoa', itemId], () => Get(CHUYENKHOA_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });

    const editMutation = useMutation((value) => Put(CHUYENKHOA_API.UPDATE_ITEM, itemId, value));

    const handleEdit = (values) => {
        editMutation.mutate(values, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    queryClient.setQueryData(['chuyenKhoa', itemId], values);
                    history.push(URI_INTERNAL.CHUYENKHOA_PATH);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    if (itemQuery.isLoading) {
        return <div>Đang tải....</div>;
    }

    if (itemQuery.isError || !itemQuery.data) {
        return <div>Có lỗi xảy ra hoặc không tìm thấy chuyên khoa</div>;
    }

    const currentData = itemQuery.data;

    return (
        <Card>
            <Card.Header as="h5">Sửa chuyên khoa</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        maChuyenKhoa: currentData.maChuyenKhoa || currentData.MaChuyenKhoa || '',
                        tenChuyenKhoa: currentData.tenChuyenKhoa || currentData.TenChuyenKhoa || '',
                        moTa: currentData.moTa || currentData.MoTa || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Mã chuyên khoa',
                                        name: 'maChuyenKhoa',
                                        value: values.maChuyenKhoa,
                                        onChange: handleChange,
                                        isInvalid: errors.maChuyenKhoa,
                                        error: errors.maChuyenKhoa
                                    },
                                    {
                                        label: 'Tên chuyên khoa',
                                        name: 'tenChuyenKhoa',
                                        value: values.tenChuyenKhoa,
                                        onChange: handleChange,
                                        isInvalid: errors.tenChuyenKhoa,
                                        error: errors.tenChuyenKhoa
                                    },
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Mô tả
                                </Form.Label>
                                <Col sm="10">
                                    <Col sm="10">
                                        <Editor
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={(value) => {
                                                setFieldValue(
                                                    'moTa',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary">
                                            Cập nhật
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.CHUYENKHOA_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default ChuyenKhoaEdit;
